import { FC } from "react";
import { Backdrop } from "@mui/material";
import { LogoSolar } from "src/framework/components/commons";
import { Theme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Icon } from "@mui/material";
import { orange } from "@mui/material/colors";
import "./style.css";
import { Grid } from "@mui/material";
import { useObservable } from "src/framework/store/storeUtil";
import { isLoading$ } from "src/framework/store/AppStore";
import theme from "src/theme/light";

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.modal + 20,
      backgroundColor: "rgba(255,255,255,0.74)",
    },
  })
);

const Loader: FC = () => {
  const classes = useStyles();
  const isLoading = useObservable(isLoading$)

  return (
    <div>
      <Backdrop open={isLoading} className={classes.backdrop}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid>
            <Icon
              className="spin"
              style={{ fontSize: "40px", color: orange[500] }}
            >
              wb_sunny
            </Icon>
          </Grid>
          <Grid>
            <LogoSolar fillIntelbras={"#00B26B"} width={"200px"} />
          </Grid>
        </Grid>
      </Backdrop>
    </div>
  );
};

export { Loader };
